import React, { useState } from 'react'
import { Dialog, Tooltip, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import DialogView from '../../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'

function DeletePlanDeEmbarqueBodega (props) {
  const { handleDelete } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='sm'>
        <DialogView
          confirmCallback={handleDelete}
          cancelCallback={handleClose}
          title='Eliminar detalle de bodega'
          content={<DialogConfirmacionContent
            message='¿Esta seguro que desea eliminar el detalle de plan de embarque seleccionado?'
          />
          }
        />
      </Dialog>
      <Tooltip title={'Eliminar'}>
        <IconButton onClick={handleOpen}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export default DeletePlanDeEmbarqueBodega
